import { IconProp, RotateProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { ColorBadge } from "@atoms"
import { ColorBadgeProps } from "@atoms/ColorBadge/ColorBadge.types"

import { PaymentBadgeProps, PaymentLevel } from "./PaymentBadge.types"

const paidIcon = faIcon({ name: "circle-check", style: "solid" })
const partialIcon = faIcon({ name: "circle-half-stroke", style: "solid" })
const unpaidIcon = faIcon({ name: "circle-xmark", style: "regular" })
const unpaidEscalatedIcon = faIcon({ name: "circle-xmark", style: "solid" })

interface Presentation {
    icon: IconProp
    iconRotation?: RotateProp
    colorScheme: ColorBadgeProps["colorScheme"]
}

// Shared icon + color vocabulary for every payment-level badge. The single source of
// truth for how a payment state looks.
function resolvePresentation(level: PaymentLevel, isEscalated: boolean): Presentation {
    switch (level) {
        case "full":
            return { icon: paidIcon, colorScheme: "jade" }
        case "partial":
            return { icon: partialIcon, iconRotation: 180, colorScheme: isEscalated ? "tomato" : "amber" }
        case "none":
            return isEscalated
                ? { icon: unpaidEscalatedIcon, colorScheme: "tomato" }
                : { icon: unpaidIcon, colorScheme: "gray" }
    }
}

export default function PaymentBadge(props: PaymentBadgeProps) {
    const { level, isEscalated = false, tooltip, size = "md", children } = props

    const { icon, iconRotation, colorScheme } = resolvePresentation(level, isEscalated)

    return (
        <ColorBadge
            colorScheme={colorScheme}
            size={size}
            variant="icon"
            icon={icon}
            iconRotation={iconRotation}
            tooltip={tooltip}
        >
            {children}
        </ColorBadge>
    )
}
